export default {
  // 期间管理查询
  GET_LIST_FINANCE: '/financial/financeLedgerPeriod/queryList',
  // 获取分类账名称
  GET_LEGER_CODE_NAME: '/maindata/ledger/codeName',
  //打开
  OPEN: '/financial/financeLedgerPeriod/open',
  //关闭
  CLOSE: '/financial/financeLedgerPeriod/close',
  exportPrint: 'sales/orderTrade/exportPrint',
  // 期间关闭检查
  CLOSE_CHECK: '/financial/financeLedgerPeriod/closeCheck',
};
